<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="frontmatter" id="ser">
<p class="rvh">Praise for <i>Science Fiction Theatre</i></p>
<p class="rvf">“J. P. Telotte is the dean of science fiction scholarship. His work is as readable as it is insightful. <i>Science Fiction Theatre</i> is an immensely enjoyable book that combines a history of early television with an analysis of a show that initiated all the TV and streaming sci-fi that came in its wake.”</p>
<p class="rvt">—Robert P. Kolker, coauthor with Nathan Abrams of <i>Kubrick: An Odyssey</i></p>
<p class="rvf">“At a moment when televised science fiction is experiencing its latest golden age, J. P. Telotte’s media-savvy study returns us to one of its most important origin points, revealing <i>Science Fiction Theatre</i> as the unrecognized and underappreciated ancestor of everything from <i>The Twilight Zone</i> and <i>Black Mirror</i> to <i>Star Trek</i> and <i>The X-Files</i>.”</p>
<p class="rvt">—Gerry Canavan, managing editor of <i>Science Fiction Film and Television</i></p>
<p class="rvf">“In J. P. Telotte’s <i>Science Fiction Theatre</i>, our most accomplished scholar of science fiction film examines the anthology series that paved the way for <i>The Twilight Zone</i> and <i>Star Trek</i>. Telotte excels at connecting the circumstances of production—economic, political, social, and technological—with the images and ideas that made their way onto TV screens and into the national consciousness.”</p>
<p class="rvt">—Brian Attebery, author of <i>Fantasy: How It Works</i></p>
<p class="rvf">“A deeply researched and accessibly written account of a pioneering television series, locating <i>Science Fiction Theatre</i> in the contexts of postwar popular culture, the science fiction genre, and the American television industry.”</p>
<p class="rvt">—William Boddy</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-tvmsciencefiction-0002.vue?3225e3db